import { ICellRendererParams } from "ag-grid-community";

const KeywordInfoCellRenderer = (params: ICellRendererParams) => {
    return (
        <>
            <div className="keyword-review">
                <div style={{
                    fontSize: "14px",
                    color: "black",
                    fontWeight: "900",
                    marginBottom: "5px"
                }}>
                    {params.data.matchType !== "asinSameAs" ? 'Keyword' : 'Target'}
                    : <span className="text-secondary">{params.data.keywordName}</span>
                </div>
                <div >Campaign: {params.data.campaignName}</div>
                <div >Adgroup: {params.data.adgroupName}</div>
                <div >Match Type: <b>{params.data.matchType}</b></div>
            </div>
        </>
    )
}

export default KeywordInfoCellRenderer;